import { render, staticRenderFns } from "./MessageLimit.vue?vue&type=template&id=1b0243f0&scoped=true"
import script from "./MessageLimit.vue?vue&type=script&lang=js"
export * from "./MessageLimit.vue?vue&type=script&lang=js"
import style0 from "./MessageLimit.vue?vue&type=style&index=0&id=1b0243f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0243f0",
  null
  
)

export default component.exports